<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useStore } from '@/core/store'
import { serverService } from '@/core/services'
import type Server from '@/core/resources/Server'
import FileBrowser from '@/components/browser/FileBrowser.vue'

const store = useStore()
const selectedServer = ref<Server | null>(null)
const servers = ref<Server[]>([])

onMounted(() => {
  serverService.getAll(store.getAccessToken()).then((res) => {
    servers.value = res
  })
})

const refreshBrowser = () => {
  const server = selectedServer.value
  selectedServer.value = null
  setTimeout(() => {
    selectedServer.value = server
  }, 0)
}
</script>

<template>
  <div class="container">
    <h1>File Browser</h1>

    <div class="server-select">
      <label for="server-select">Select a server:</label>
      <select v-model="selectedServer" @change="refreshBrowser" id="server-select">
        <option v-for="server in servers" :key="server.id" :value="server">
          {{ server.name }}
        </option>
      </select>
    </div>

    <FileBrowser v-if="selectedServer" :server="selectedServer" />
    <p v-else>No server selected</p>
  </div>
</template>

<style scoped lang="scss">
.container {
  width: clamp(100px, 95%, 1200px);
  margin: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  word-break: keep-all;

  p {
    color: #666;
  }
}

.server-select {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
}

select {
  padding: 0.4rem;
  border: 1px solid var(--theme-border-color);
  border-radius: 0.2rem;
  background-color: var(--theme-panel);

  transition: background-color 0.2s;

  &:disabled {
    background-color: var(--theme-panel-secondary);
    color: #666;
  }
}
</style>
